import { LeftArrow, PickListLoader, RightArrowIcon } from '../assets/svgImages';
import { PickListProps } from '../interface/interface';

export const PickList = (prps: PickListProps) => {
  return (
    <>
      <div className="flex w-full justify-center">
        {/* left Side */}
        <div className="block max-w-sm border border-gray-200 rounded-lg bg-white h-96 relative flex-auto">
          <div className="p-5 border-b">
            <p className="text-sm font-semibold  text-secondary-pink-700">
              {prps.left.title}
            </p>
            <div className="relative mt-2">
              <input
                type="text"
                name="seach"
                onChange={(event) =>
                  prps.left.setSearchInputInfo(event.target.value)
                }
                id="name"
                className="peer block w-full border-0 bg-gray-50 text-gray-900 focus:ring-0 sm:text-sm sm:leading-6"
                placeholder="Search..."
              />
              <div
                className="absolute inset-x-0 bottom-0 border-t border-gray-300 peer-focus:border-t-2 peer-focus:border-indigo-600"
                aria-hidden="true"
              />
            </div>
          </div>
          {prps.left.loading ? (
            <PickListLoader />
          ) : (
            <div className="divide-y divide-slate-200 overflow-y-scroll absolute w-full h-3/5">
              {...prps.left.items}
            </div>
          )}
        </div>
        {/* Controller Buttons */}
        <div className="flex flex-col mx-4 items-center justify-center space-y-2">
          <button
            onClick={() => prps.moveSelected('right')}
            className={`bg-primary-blue-500 border border-solid border-primary-blue-500 text-white px-4 py-2 w-12 
            h-12 rounded ${!prps.left.isActionEnabled ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            <RightArrowIcon />
          </button>
          <button
            onClick={() => prps.moveSelected('left')}
            className={`bg-primary-blue-500 border border-solid border-primary-blue-500 text-white px-4 py-2 w-12 
            h-12 rounded ${!prps.right.isActionEnabled ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            <LeftArrow />
          </button>
        </div>
        {/* Right Side */}
        <div className="block max-w-sm border border-gray-200 rounded-lg bg-white h-96 relative flex-auto">
          <div className="p-5 border-b">
            <p className="text-sm font-semibold  text-secondary-pink-700">
              {prps.right.title}
            </p>
          </div>
          {prps.right.loading ? (
            <PickListLoader />
          ) : (
            <div className="divide-y divide-slate-200 overflow-y-scroll absolute w-full h-4/5">
              {...prps.right.items}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
